import { render, staticRenderFns } from "./plmOperationMaterial.vue?vue&type=template&id=1b425cc4&scoped=true"
import script from "./plmOperationMaterial.vue?vue&type=script&lang=js"
export * from "./plmOperationMaterial.vue?vue&type=script&lang=js"
import style0 from "./plmOperationMaterial.vue?vue&type=style&index=0&id=1b425cc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b425cc4",
  null
  
)

export default component.exports